// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ModalFiltrosComplexos - Estilos genéricos para filtros complexos */

.styles_modalTitle__uJxli {
  background: white;
  padding: 0.75rem 1.25rem;
  border-bottom: 1px solid #e0e0e0;
}

.styles_titleContainer__47ZSd {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.styles_modalContent__ZdGa0 {
  padding: 1rem 1.25rem;
  min-height: 200px;
  background-color: #fff;
}

.styles_filtrosContainer__MKets {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.styles_emptyState__8iABc {
  padding: 1.5rem 1rem;
  text-align: center;
  background-color: #f8f9fa;
  border-radius: 6px;
  border: 1px dashed #dee2e6;
}

.styles_filtroRow__tnUfJ {
  padding: 0.75rem 0;
  border-bottom: 1px solid #ddd;
  background-color: #fff;
  transition: background-color 0.2s ease;
}

.styles_filtroRow__tnUfJ:hover {
  background-color: #f5f5f5;
}

.styles_addFilterContainer__IAq3E {
  padding: 0.5rem 0;
  display: flex;
  justify-content: center;
}

.styles_modalActions__tVfE- {
  padding: 0.75rem 1.25rem !important;
  margin: 0 !important;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;
  background-color: #fff;
  border-top: 1px solid #e0e0e0;
}

.styles_buttonGroupLeft__WKhFJ {
  display: flex;
  gap: 0.75rem;
  flex: 1 1;
  justify-content: flex-start;
}

.styles_buttonGroupRight__rzwLU {
  display: flex;
  gap: 0.75rem;
  flex: 1 1;
  justify-content: flex-end;
}

/* Estilos dos botões */
.styles_btnFechar__uTTvp {
  text-transform: uppercase !important;
  color: #18316e !important;
  border: 1px solid #18316e !important;
  font-family: "Inter" !important;
  font-weight: 400 !important;
  transition: all 0.3s ease !important;
}

.styles_btnFechar__uTTvp:hover {
  background-color: rgba(24, 49, 110, 0.04) !important;
  transform: scale(0.95) !important;
  opacity: 0.9;
}

.styles_btnAplicar__MPhfL {
  text-transform: uppercase !important;
  font-family: "Inter" !important;
  font-weight: 400 !important;
  transition: all 0.3s ease !important;
  background-color: #18316e !important;
  color: white !important;
}

.styles_btnAplicar__MPhfL:hover {
  background-color: #0f1f4a !important;
  transform: scale(0.95) !important;
}

.styles_btnAplicar__MPhfL:disabled {
  background-color: #ccc !important;
  color: #666 !important;
  transform: none !important;
}

/* Responsividade */
@media (max-width: 768px) {
  .styles_modalActions__tVfE- {
    flex-direction: column;
    gap: 0.5rem;
  }

  .styles_buttonGroupLeft__WKhFJ,
  .styles_buttonGroupRight__rzwLU {
    justify-content: center;
    width: 100%;
  }

  .styles_filtroRow__tnUfJ {
    padding: 0.5rem;
  }

  .styles_modalContent__ZdGa0 {
    padding: 0.75rem;
  }

  .styles_modalTitle__uJxli {
    padding: 0.5rem 0.75rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ModalFiltrosComplexos/styles.module.css"],"names":[],"mappings":"AAAA,qEAAqE;;AAErE;EACE,iBAAiB;EACjB,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,oBAAoB;EACpB,8BAA8B;EAC9B,WAAW;EACX,sBAAsB;EACtB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,SAAO;EACP,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,SAAO;EACP,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,oCAAoC;EACpC,yBAAyB;EACzB,oCAAoC;EACpC,+BAA+B;EAC/B,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,oDAAoD;EACpD,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;EAC/B,2BAA2B;EAC3B,oCAAoC;EACpC,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA,mBAAmB;AACnB;EACE;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;;IAEE,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;AACF","sourcesContent":["/* ModalFiltrosComplexos - Estilos genéricos para filtros complexos */\n\n.modalTitle {\n  background: white;\n  padding: 0.75rem 1.25rem;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.titleContainer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.modalContent {\n  padding: 1rem 1.25rem;\n  min-height: 200px;\n  background-color: #fff;\n}\n\n.filtrosContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n}\n\n.emptyState {\n  padding: 1.5rem 1rem;\n  text-align: center;\n  background-color: #f8f9fa;\n  border-radius: 6px;\n  border: 1px dashed #dee2e6;\n}\n\n.filtroRow {\n  padding: 0.75rem 0;\n  border-bottom: 1px solid #ddd;\n  background-color: #fff;\n  transition: background-color 0.2s ease;\n}\n\n.filtroRow:hover {\n  background-color: #f5f5f5;\n}\n\n.addFilterContainer {\n  padding: 0.5rem 0;\n  display: flex;\n  justify-content: center;\n}\n\n.modalActions {\n  padding: 0.75rem 1.25rem !important;\n  margin: 0 !important;\n  justify-content: space-between;\n  width: 100%;\n  box-sizing: border-box;\n  background-color: #fff;\n  border-top: 1px solid #e0e0e0;\n}\n\n.buttonGroupLeft {\n  display: flex;\n  gap: 0.75rem;\n  flex: 1;\n  justify-content: flex-start;\n}\n\n.buttonGroupRight {\n  display: flex;\n  gap: 0.75rem;\n  flex: 1;\n  justify-content: flex-end;\n}\n\n/* Estilos dos botões */\n.btnFechar {\n  text-transform: uppercase !important;\n  color: #18316e !important;\n  border: 1px solid #18316e !important;\n  font-family: \"Inter\" !important;\n  font-weight: 400 !important;\n  transition: all 0.3s ease !important;\n}\n\n.btnFechar:hover {\n  background-color: rgba(24, 49, 110, 0.04) !important;\n  transform: scale(0.95) !important;\n  opacity: 0.9;\n}\n\n.btnAplicar {\n  text-transform: uppercase !important;\n  font-family: \"Inter\" !important;\n  font-weight: 400 !important;\n  transition: all 0.3s ease !important;\n  background-color: #18316e !important;\n  color: white !important;\n}\n\n.btnAplicar:hover {\n  background-color: #0f1f4a !important;\n  transform: scale(0.95) !important;\n}\n\n.btnAplicar:disabled {\n  background-color: #ccc !important;\n  color: #666 !important;\n  transform: none !important;\n}\n\n/* Responsividade */\n@media (max-width: 768px) {\n  .modalActions {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n\n  .buttonGroupLeft,\n  .buttonGroupRight {\n    justify-content: center;\n    width: 100%;\n  }\n\n  .filtroRow {\n    padding: 0.5rem;\n  }\n\n  .modalContent {\n    padding: 0.75rem;\n  }\n\n  .modalTitle {\n    padding: 0.5rem 0.75rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalTitle": `styles_modalTitle__uJxli`,
	"titleContainer": `styles_titleContainer__47ZSd`,
	"modalContent": `styles_modalContent__ZdGa0`,
	"filtrosContainer": `styles_filtrosContainer__MKets`,
	"emptyState": `styles_emptyState__8iABc`,
	"filtroRow": `styles_filtroRow__tnUfJ`,
	"addFilterContainer": `styles_addFilterContainer__IAq3E`,
	"modalActions": `styles_modalActions__tVfE-`,
	"buttonGroupLeft": `styles_buttonGroupLeft__WKhFJ`,
	"buttonGroupRight": `styles_buttonGroupRight__rzwLU`,
	"btnFechar": `styles_btnFechar__uTTvp`,
	"btnAplicar": `styles_btnAplicar__MPhfL`
};
export default ___CSS_LOADER_EXPORT___;
